const TOASTMASTER_API_URL = '/api';
const EVALUATE_GUIDELINE_URL = 'https://www.toastmasters.org/Resources/How%20to%20Evaluate'

export {
  TOASTMASTER_API_URL,
  EVALUATE_GUIDELINE_URL,
};

export const EDX_LOGIN_COOKIE = 'edxloggedin';

/*
============================================
  Toastmaster user's roles
============================================
*/
export const ROLE: any = {
  ADMIN: {
    id: 1,
    name: 'Admin',
    isChecked: false,
  },
  SPEECHCRAFT_COORDINATOR: {
    id: 2,
    name: 'Coordinator',
    isChecked: false,
    code: 'EDLYSCC',
  },
  CLUB_MEMBER: {
    id: 3,
    name: 'Club Member',
    isChecked: false,
  },
  DISTRICT_LEADER: {
    id: 4,
    name: 'District Leader',
    isChecked: false,
  },
  CLUB_OFFICER: {
    id: 5,
    name: 'Club Officer',
    isChecked: false,
  },
  SPEECHCRAFTER: {
    id: 6,
    name: 'Speechcrafter',
    isChecked: false,
    code: 'EDLYSCA',
  },
  BASE_CAMP_MANAGER: {
    id: 7,
    name: 'Base Camp Manager',
    isChecked: false,
  },
};

export const COURSE_CATEGORY = {
  SUGGESTED: 'suggested',
  COMPLETED: 'completed',
};

export const DEFAULT_PAGE_SIZE = 20;

export const BADGES_FILTER_TYPE = {
  COMPLETED: 'completed',
  AVAILABLE: 'available',
  ALL: 'all',
};

export const COURSE_STATUS = {
  REGISTERED: 'registered',
  AVAILABLE: 'available',
  IN_PROGRESS: 'in progress',
  COMPLETED: 'completed',
};

export const INITIAL_FILTERS_STATE = {
  category: {},
  subCategory: {},
  language: {},
};

export const SORT_OPTIONS = [
  { label: 'All Filters', value: 'All Filters' },
  { label: 'Shared with me', value: 'shared' },
  { label: 'Recently Viewed', value: 'recently viewed' },
  { label: 'Favorites', value: 'favorites' },
];

export const ACCEPTED_VIDEO_FORMATS = [
  'mpeg',
  'wmv',
  'mov',
  'x-msvideo',
  'mp4',
  'quicktime',
  '3gpp',
  'x-flv',
  'x-ms-wmv',
];

export const REQUESTS_SORT_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'To Do', value: 'pending' },
  { label: 'Submitted', value: 'submitted' },
];

export const REQUESTS_SORT_OPTIONS_PATHWAYS = [
  { label: 'All', value: '' },
  { label: 'To Do', value: 'pending' },
  { label: 'Submitted', value: 'submitted' },
];

export const APPROVALS_SORT_OPTIONS_PATHWAYS = [
  { label: 'All', value: '' },
  { label: 'Approved', value: 'approved' },
  { label: 'Denied', value: 'denied' },
  { label: 'To Do', value: 'pending' },
  { label: 'Reversed', value: 'reversed' },
];

export const REQUESTS_SORT_OPTIONS_SPEECHCRAFT = [...REQUESTS_SORT_OPTIONS];

export const REQUEST_TYPES = {
  APPROVAL: 'approval',
  EVALUATION: 'evaluation',
};

export const REQUEST_STATUS = {
  PENDING: 'Pending',
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  DENIED: 'Denied',
};

export const APPROVAL_REQUEST_STATUS: any = {
  Denied: 'Denied',
  Pending: 'Review',
  Approved: 'Approved',
  Reversed: 'Reversed',
};

export const NOTIFICATION_TYPES = {
  evaluationRequest: 'evaluation_request',
  evaluationRequestReview: 'evaluation_request_review',
  feedbackSent: 'feedback_sent',
  feedbackRequested: 'feedback_requested',
  completionRequest: 'completion_request',
  courseEnrollment: 'course_enrollment',
  completionReview: 'completion_review',
  badgeEarned: 'badge_earned',
  completionReviewNotifyBCM: 'completion_review_notify_bcm',
  resourceShared: 'resource_shared',
  evaluationDirectReview: 'evaluation_direct_review',
  preCourseEnrollment: 'pre_course_enrollment',
  completionRequestFirstReminder: 'completion_request_first_reminder',
  completionRequestSecondReminder: 'completion_request_second_reminder',
  feedbackBadgeEarned: 'feedback_badge_earned',
  courseInactivity: 'course_inactivity',
  pathwaysMentorProgramEnrollment: 'pathways_mentor_program_enrollment',
  clubCoachModuleEnrollment: 'club_coach_module_enrollment',
  speechcrafterCertificate: 'speechcrafter_certificate',
  speechcrafterLastSelfAssessment: 'speechcrafter_last_self_assessment',
  speechcraftEventEnd: 'end_speechcraft_event',
  clubAssociationChange: 'club_association_change',
  reverse_completion_project: 'reverse_completion_project',
  reverse_completion_level: 'reverse_completion_level',
  reverse_completion_path: 'reverse_completion_path',
};

export const BADGE_HASH_TYPES = {
  learnerBadge: '#learner-badge',
  feedbackBadge: '#feedback-badge',
  speechBadge: '#speech-badge',
};

export const BADGE_TYPES = {
  learnerBadge: 'PW',
  learnerFeedbackBadge: 'PW_FB',
  speechFeedbackBadge: 'SC_FB',
  speechBadge: 'SC',
};

export const NOTIFICATION_INTERVAL = 500000;

export const MFE_CONFIG = {
  speechcraft: {
    config: {
      showSelfAssessments: true,
      showAchievements: true,
      showPathLearning: false,
      showFeedback: true,
      showResources: true,
      showCoordinatorHome: true,
      speechcrafters: true,
      showSpeechcrafterHome: true,
    },
  },
  pathways: {
    config: {
      showSelfAssessments: false,
      showAchievements: true,
      showPathLearning: true,
      showFeedback: true,
      showResources: true,
      showCoordinatorHome: false,
      speechcrafters: false,
      showSpeechcrafterHome: false,
    },
  },
};

export const SPEECH_CRAFT_MFE = 'speechcraft';

export enum Role {
  coordinator = 'EDLYSCC',
  speechcrafter = 'EDLYSCA',
}

export enum AdminUsers {
  isSystemUser = 'is-system-user'
}

export enum Levels {
  level1 = 'level-1',
  level2 = 'level-2',
  level3 = 'level-3',
  level4 = 'level-4',
  level5 = 'level-5',
}

export const ErrorTypes = {
  Platform_Access_Denied: 'NO_PLATFORM_ACCESS',
  No_Current_Event: 'NO_CURRENT_EVENT',
  Event_Expired: 'EVENT_EXPIRED',
  Not_Event_Participant: 'NOT_EVENT_PARTICIPANT',
};

export const ErrorMessages = {
  NO_PLATFORM_ACCESS:
    'This page you are trying to reach has restricted access. If you feel you have received this message in error, log out and back in.',
  NO_CURRENT_EVENT:
    'This page you are trying to reach has restricted access. If you feel you have received this message in error, log out and back in.',
  EVENT_EXPIRED:
    'This page you are trying to reach has restricted access. If you feel you have received this message in error, log out and back in.',
  NOT_EVENT_PARTICIPANT:
    'This page you are trying to reach has restricted access. If you feel you have received this message in error, log out and back in.',
};

export enum TICourses {
  PMP = 'pathways mentor program',
  DTM = 'distinguished toastmaster',
  CCP = 'club coach program',
  CBI = 'club building initiative',
}

export const EXPLORATIONS_CONTENT_GROUP_VALUE = 'explorations';
